import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class PhotographyAndVideoShoots extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Photography and Video Shoots"
					title={"photography and video shoots"}
					image={require('./image-11.jpg')}
				/>
				<div className="entry-content page-blog">


				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Photography and Video Shoots
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>Quality photography and video footage is usually the make or break decider in capturing a viewer’s attention. How many times have you gone to watch a video only to get frustrated with poor audio or visual quality? Your following has a huge chance to grow with high quality, creative content. 
</p>

								<h4>Is your content as engaging as it could be?</h4>
								
       <ul class="with-icons">
              <li>Are people being pulled in by your creative content?</li>
              <li>Or are you unintentionally turning off potential audiences with poor images?</li>

        </ul>
    <p>Our creative team at Moshi Moshi Marketing have displayed at local and international photography exhibitions, have assisted with Google 360° shoots and have over 15 years experience in the commercial and creative photography fields. We even specialise in cinemagraphs (moving photos), that make for captivating social posts or web banners. 

</p>
<p>At Moshi Moshi we love playing with the newest video technology too - the office drone gets quite a bit of flight time! Video footage is still the primary engagement driver on social media, giving more immersive customer experiences with your content. 

</p>


<p>We offer our photography and video services for your social media pages, website pages, graphic design, public events and more.</p> 
<p>If you’re interested in TV video advertising, check out our <a href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">Video Production and Advertising</a> page. </p>
<img src={require('./Backbeach2.png')} style={{padding: 30}} height="375" width="350" alt="Photography for Backbeach Cafe" className="align-centre" align="centre" />

<img src={require('./Backbeach.png')} style={{padding: 30}} height="375" width="350" alt="Photography for Backbeach Cafe" className="align-centre" align="centre" />

<img src={require('./Backbeach3.png')} style={{padding: 30}}  height="375" width="350" alt="Photography for Backbeach Cafe" className="align-centre" align="centre" />
<a href="https://www.moshi.com.au/what-weve-done/bunbury-central"><img src={require('./BC3.png')} style={{padding: 30}} height="375" width="350" alt="Photography for the Bunbury Central Website" className="align-centre" align="centre" /></a>

<a href="https://www.moshi.com.au/what-weve-done/bunbury-central"><img src={require('./BC2.png')} style={{padding: 30}} height="375" width="350" alt="Photography for the Bunbury Central Website" className="align-centre" align="centre" /></a>

<a href="https://www.moshi.com.au/what-weve-done/bunbury-central"><img src={require('./BC1.png')} style={{padding: 30}} height="375" width="350" alt="Photography for the Bunbury Central Website" className="align-centre" align="centre" /></a>
<br></br>
<hr></hr>


<h2>Related Services</h2>

<a class="btn" href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">Video Production and Advertising</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 
<a class="btn" href="https://www.moshi.com.au/whatwedo/graphic-design">Graphic Design</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/public-relations">Public Relations</a>
		
<a class="btn" href="https://www.moshi.com.au/whatwedo/brand-and-logo-design">Brand and Logo Design</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>
		
		
		
		

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>

<hr></hr>
<br></br>
<h4>If you’re ready to make your content sing, get in touch with the team at Moshi Moshi Marketing.</h4>
<h3> Gain more customers with captivating, creative photographs and footage. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default PhotographyAndVideoShoots;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/PhotographyAndVideoShoots.js